import template from './heading.html';

export const confirmWarrantHeadingComponent = {
  name: 'confirmWarrantHeading',
  restrict: 'E',
  template,
  controllerAs: 'vm',
  bindings: {
    title: '@',
    description: '@',
  },
};
